<template>
  <!-- 正装选择 -->
  <div class="clothes-wrapper flex">
    <div class="gender-container flex">
      <div class="gender-item flex" :class="{active: activeGender === 'boy_list'}" @click="handleClick('boy_list')">男装</div>
      <div class="gender-item flex" :class="{active: activeGender === 'girl_list'}" @click="handleClick('girl_list')">女装</div>
    </div>
    <div class="gender-list-container">
      <cube-scroll
        ref="scroll"
        :data="renderList"
        direction="horizontal"
        class="horizontal-scroll-list-wrap-1">
        <div class="list-wrapper-1 flex">
<!--          <img v-for="item in renderList" class="list-item" :src="item.url" />-->
          <div class="list-item-1 special-item flex" :class="{active: nowClothesId === -1}" @click="handleChangeId(-1)">
            <span class="iconfont iconGroup2" />
            <span>无正装</span>
            <span class="iconfont iconcheck" v-if="nowClothesId === -1" />
          </div>
          <div v-for="item in renderList" class="list-item-1" :key="item.url" :class="{active: nowClothesId === item.id}" @click="handleChangeId(item.id)">
            <img :src="item.url" alt="">
            <span class="iconfont iconcheck" v-if="nowClothesId === item.id" />
          </div>
        </div>
      </cube-scroll>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabDataClothes: {
      type: Object,
      default: () => {}
    },
    activeGender: {
      type: String,
      default: "boy_list"
    },
    nowClothesId: {
      type: [Number, String],
      default: -1
    }
  },
  data() {
    return {

    }
  },
  watch: {

  },
  mounted() {

  },
  computed: {
    renderList() {
      return this.tabDataClothes[this.activeGender] ? this.tabDataClothes[this.activeGender] : []
    }
  },
  methods: {
    handleChangeId(id) {
      this.$emit('changeId', id)
    },
    handleClick(type) {
      // this.activeGender = type
      this.$emit('changeGender', type)
    }
  }
}
</script>
<style lang="scss" scoped>
.clothes-wrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 0;
  flex-direction: column;
  justify-content: space-between;
  .gender-container {
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 20px;
    .gender-item {
      width: 56px;
      height: 24px;
      font-size: 13px;
      color: #9c9c9c;
      border-radius: 13px;
      align-items: center;
      justify-content: center;
      &.active {
        background: rgba(103, 156, 255, .1);
        color: #679CFF;
      }
    }
  }
  .gender-list-container {
    //flex: 1;
    width: 100%;
    height: 80px;
    //width: 200px;
    .horizontal-scroll-list-wrap-1 {
      width: 100%;
      height: 100%;
      /deep/ .cube-scroll-content {
        height: 100%;
        display: inline-block;
        .cube-scroll-list-wrapper {
          height: 100%;
        }
        .list-wrapper-1 {
          height: 100%;
          gap: 15px;
        }
        .list-item-1 {
          //height: 100%;
          //width: 45px;
          //height: 45px;
          width: 64px;
          height: 54px;
          border-radius: 8px;
          //overflow: hidden;
          border: 1px solid transparent;
          position: relative;
          &.special-item {
            background: #F5F8FF;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: #bcbcbc;
            gap: 5px;
            .iconfont {
              font-size: 20px;
            }
          }
          &.active {
            border-color: #679CFF;
            .iconcheck {
              color: #679CFF;
              font-weight: 800;
              position: absolute;
              left: 50%;
              bottom: -30px;
              transform: translateX(-50%);
            }
          }
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>
